<template>
  <div v-if="personaliseableData" :class="['owc-wb-table', { 'owc-wb-table--dark': isDarkMode }]">
    <div v-html="formattedTableData" class="wb-grid-container"></div>
    <div v-if="footnotes" class="owc-wb-table__footnotes wb-grid-container">
      <globalelem-footnote-component
        :module-id="moduleId"
        :theme="isDarkMode ? 'dark' : 'light'"
      ></globalelem-footnote-component>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import Personalisation from '@owc-utils/Mixins/Personalisation';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import { WbTableComponent } from '@owc-packages/WbTable/src/WbTable';
import { getLocalFootnotes, setModuleId } from '../../_utils/Footnotes/FootnotesHelper';

export default (ComponentInitializeDispatcher as WbTableComponent).extend({
  name: 'owc-wb-table',
  components: {
    SlotContainer,
  },
  mixins: [Personalisation],
  computed: {
    formattedTableData: function() {
      return this.personaliseableData?.formattedTableData;
    },
    isDarkMode: function() {
      return Boolean(this.personaliseableData?.darkMode);
    },
    footnotes() {
      return getLocalFootnotes(this.personaliseableData);
    },
    moduleId() {
      return setModuleId(this);
    },
  },
});
</script>
<style lang="scss">
@import '@owc-styles/utils/rte';

.owc-wb-table {
  padding: var(--wb-spacing-xs) 0;

  .owc-wb-table__footnotes {
    margin-top: var(--wb-spacing-m);
  }
  &--dark {
    background-color: var(--wb-black);
  }
}
</style>
